import React from 'react';
import { Tag, TagType, TagVariant } from '@cmhc-schl/hearth-ui';

interface StatusFieldProps {
  ok: boolean;
  status: string;
}

export const StatusField = ({ ok, status }: StatusFieldProps) => {
  const color = ok ? 'Green' : 'Gray';

  return (
    <Tag
      label={status}
      tagType={TagType.TAG}
      tagVariant={TagVariant.ICON_READONLY}
      statusIndicator={color}
      showStatusIndicator={true}
      filled={true}
    />
  );
};
